import styled from 'styled-components';
import { getSizeBy, getColorShade } from '../../../src/styled/utils';
import { Button } from '../button';
import { ButtonGroup } from '../button-group';
import { Subtitle2Styles } from '../typography';
const BUTTON_SIZE = '35px';
/*
 * Range styles
 */
export const RangeWrapper = styled.ul `
  display: inline-grid;
  grid-template-columns: repeat(3, auto);
  align-items: center;
  column-gap: ${getSizeBy(7)};
`;
export const RangePrevButton = styled.li ``;
export const RangeCounter = styled.li `
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  ${Subtitle2Styles};
`;
export const RangeNextButton = styled.li ``;
/*
 * Pagination styles
 */
export const PaginationWrapper = styled(ButtonGroup) ``;
export const PaginationItem = styled(Button) `
  width: ${BUTTON_SIZE};
  height: ${BUTTON_SIZE};
  padding: initial;

  & > span {
    color: ${({ isActive }) => isActive
    ? getColorShade('onSurface', 'highEmphasis')
    : getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
export const PaginationNavArrow = styled(Button) `
  width: ${BUTTON_SIZE};
  height: ${BUTTON_SIZE};
  padding: initial;
`;
